import angular from "angular";

import templateUrl from './ncr-summary-container.component.html'

export const NcrSummaryContainerComponent = {
    templateUrl,
    controller: NcrSummaryContainerController,
    controllerAs: "vm",
    bindings: {
        payrollID: "<?payrollId",
        icdCorporationID: "<?icdCorporationId"
    }
}
function NcrSummaryContainerController($q, $uibModal, icdCorporationService, payrollDashboardService,
    payrollService, utilityService, rsPayoutTransfersService,) {
    'ngInject'
    const vm = this;

    vm.$onInit = onInit;
    vm.filters;
    vm.ncrSummaryList;
    vm.handleChangePayWeek = handleChangePayWeek;
    vm.handleChangeIcdCorporation = handleChangeIcdCorporation;
    vm.onChangeProgram = onChangeProgram;
    vm.selectedIcdCorporation;
    vm.payrollID;
    vm.onEdit = onEdit;
    vm.storeList;
    vm.pristinersPayoutTransfers = [];
    vm.totalsPayoutTransfers;
    vm.rsPayoutTransfers;

    function onInit() {
        // Load list data used for initial filters before loading any page data.
        const filterListsLoaded = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payroll")
            .then(icdCorporations => {
                vm.icdCorporations = icdCorporations
                vm.selectedIcdCorporation = icdCorporations.find(p => p.Id === vm.icdCorporationID)
                    || icdCorporations[0]
                return vm.selectedIcdCorporation
            })
            .then(icdCorporation => {
                if (!icdCorporation) {
                    return null;
                }
                return payrollService.retrieveIcdCorporationPayrolls(icdCorporation.Id)
            })
            .then(payrolls => {
                vm.payrolls = payrolls.sort(sortPayroll).map(payroll => ({
                    PayWeekID: payroll.PayrollID,
                    PayrollID: payroll.PayrollID,
                    Text: kendo.format("{0:MM/dd/yyyy} - {1:MM/dd/yyyy}", payroll.StartDate, payroll.EndDate),
                    DateSpan: kendo.format("{0:MMM dd, yyyy} - {1:MMM dd, yyyy}", payroll.StartDate, payroll.EndDate),
                    StartDate: kendo.format("{0:MM/dd/yyyy}", payroll.StartDate),
                    EndDate: kendo.format("{0:MM/dd/yyyy}", payroll.EndDate),
                }))
                vm.selectedPayroll = payrolls.find(p => p.PayrollID === vm.payrollID)
                    || payrolls[0]
                return vm.selectedPayroll
            })

        const ncrSummaryLoaded = filterListsLoaded
            .then(() => {
                return loadNcrSummary()
            })

        const payoutTransfersLoaded = filterListsLoaded
            .then(() => {
                return loadPayoutTransfers()
            })

        const dataLoaded = $q.all([filterListsLoaded, ncrSummaryLoaded, payoutTransfersLoaded])

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Initial load failed")
        )
    }

    function loadNcrSummary() {
        return payrollDashboardService.retrieveNCRSummary(vm.selectedPayroll.PayrollID,
            vm.selectedIcdCorporation.Id, vm.selectedPayroll.StartDate, vm.selectedPayroll.EndDate)
            .then(function (ncrSummaryList) {
                vm.ncrSummaryList = ncrSummaryList;
                addFormattedNCRAmounts();

                vm.programList = vm.ncrSummaryList.CommissionAmounts.filter(function (program) {
                    const key = program.ProgramID + '|' + program.ProgramName;
                    if (!this[key]) {
                        this[key] = true;
                        return true;
                    }
                    return false;
                }, Object.create(null));
                vm.storeList = vm.ncrSummaryList.CommissionAmounts;
            })
    }

    function loadPayoutTransfers() {
        return rsPayoutTransfersService.retrieveRSPayoutTransfers(
            vm.selectedPayroll.StartDate, vm.selectedPayroll.EndDate, vm.selectedIcdCorporation.Id)
            .then(function (transfers) {
                vm.pristineRsPayoutTransfers = transfers;
                vm.rsPayoutTransfers = transfers;
                vm.totalsPayoutTransfers = aggregateRsPayoutTransfers(vm.rsPayoutTransfers);
                vm.totalPayoutTransferAmount = angular.copy(vm.totalsPayoutTransfers.Amount)
            })
    }


    function addFormattedNCRAmounts() {
        vm.ncrSummaryList.CommissionAmounts
        vm.ncrSummaryList.CommissionAmountFormatted = [];
        vm.ncrSummaryList.SalesNetPayoutFormatted = [];
        vm.ncrSummaryList.NetPayoutTransferFormatted = [];

        angular.forEach(vm.ncrSummaryList.CommissionAmounts, function (ncr) {
            ncr.CommissionAmountFormatted = currencyFormat(ncr.CommissionAmount);
            ncr.SalesNetPayoutFormatted = currencyFormat(ncr.SalesNetPayout);
            ncr.NetPayoutTransferFormatted = currencyFormat(ncr.NetPayoutTransfer);
        });
    }

    function currencyFormat(amount) {
        const isNegative = amount < 0;
        amount = isNegative ? -amount : amount;
        let result = amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        result = isNegative ? '($' + result + ')' : '$' + result;

        return result;
    }

    function handleChangePayWeek() {
        if (vm.selectedPayroll && vm.selectedPayroll.PayrollID) {
            const loadData = $q.all([loadNcrSummary(), loadPayoutTransfers()])
            loadData.then(() => {
                const qs = vm.selectedIcdCorporation ?
                    `?icdCorporationID=${vm.selectedIcdCorporation.Id}` : "";
                window.history.replaceState({}, "NCR Summary", `/payroll/ncrsummary/${vm.selectedPayroll.PayrollID}` + qs)
            })

            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadData, "Reloading data failed")
            )
        }
    }

    function handleChangeIcdCorporation() {
        if (vm.selectedIcdCorporation && vm.selectedIcdCorporation.Id) {
            const dataLoaded = payrollService.retrieveIcdCorporationPayrolls(vm.selectedIcdCorporation.Id)
                .then(payrolls => {
                    vm.payrolls = payrolls.map(payroll => ({
                        PayWeekID: payroll.PayrollID,
                        PayrollID: payroll.PayrollID,
                        Text: kendo.format("{0:MM/dd/yyyy} - {1:MM/dd/yyyy}", payroll.StartDate, payroll.EndDate),
                        DateSpan: kendo.format("{0:MMM dd, yyyy} - {1:MMM dd, yyyy}", payroll.StartDate, payroll.EndDate),
                        StartDate: kendo.format("{0:MM/dd/yyyy}", payroll.StartDate),
                        EndDate: kendo.format("{0:MM/dd/yyyy}", payroll.EndDate),
                    })).sort(sortPayroll)
                    vm.selectedPayroll = payrolls.find(p => vm.selectedPayroll &&
                        p.PayrollID === vm.selectedPayroll.PayrollID) || payrolls[0]
                    return vm.selectedPayroll
                })
                .then(() => {
                    if (vm.selectedPayroll && vm.selectedPayroll.PayrollID) {
                        return $q.all([loadNcrSummary(), loadPayoutTransfers()])
                    }
                })
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(dataLoaded, "Reloading data failed")
            )
        }
    }

    function onEdit() {
        $uibModal.open({
            template: '<div class="modal-header"><h1>New Payout Transfer (' + vm.selectedPayroll.Text + ')</h1></div>'
                + '<div class="modal-body">'
                + '<apex-new-rs-payout-transfer  key-collections="vm.keyCollections" after-submit="vm.afterSubmit(keyCollections)"   ></apex-new-rs-payout>'
                + '</div>'
                + '<div class="modal-footer"><button class="btn btn-plain float-right" ng-click="vm.close()">Close</button></div>',
            controller: function ($uibModalInstance, keyCollections) {
                'ngInject'
                this.keyCollections = !keyCollections ? null : keyCollections;

                this.afterSubmit = function (keyCollections) {
                    $uibModalInstance.close(keyCollections);
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            controllerAs: "vm",
            resolve: {
                keyCollections: {
                    Payweek: vm.selectedPayroll,
                    ProgramsList: vm.programList,
                    StoreList: vm.storeList,
                    IcdCorporationID: vm.selectedIcdCorporation.IcdCorporationID
                },

            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (keyCollections) {

        })
    }

    function onChangeProgram() {
        vm.programID = vm.filter.program ? vm.filter.program.ProgramID : null;
        if (vm.programID) {
            vm.rsPayoutTransfers = vm.pristineRsPayoutTransfers.filter(function (event) {
                return event.ProgramID === vm.programID;
            });
        } else {
            vm.rsPayoutTransfers = vm.pristineRsPayoutTransfers;
        }
        vm.totalsPayoutTransfers = aggregateRsPayoutTransfers(vm.rsPayoutTransfers);
    }
    function aggregateRsPayoutTransfers(payouts) {
        return payouts.reduce(function (sum, payout) {
            sum.Amount = (sum.Amount || 0) + payout.Amount;
            return sum;
        }, {});
    }

    function sortPayroll(a, b) {
        if (a.StartDate > b.StartDate) {
            return -1
        } else if (a.StartDate < b.StartDate) {
            return 1
        }
        if (a.EndDate > b.EndDate) {
            return -1
        } else if (a.EndDate < b.EndDate) {
            return 1;
        }
        return a.PayrollID - b.PayrollID;
    }
}
